<template>
    <router-view />
</template>

<style lang="scss">
    @import "@/style/main";
</style>
